import type { ClientGeoArea } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useParticipantsGeoAreaApi } from '@/features/api/hooks/participant-geo-area/useParticipantsGeoAreaApi';
import { useSharedAppApi } from '@/features/api/hooks/shared-app/useSharedAppApi';
import { getLeafs } from '@/features/geo-area/utils/geoArea';

export const useGetSelectedGeoAreas = () => {
  const api = useSharedAppApi();
  const geoApi = useParticipantsGeoAreaApi();

  const handleSelect = useCallback(
    (geoAreas: readonly ClientGeoArea[]) => getLeafs(geoAreas),
    []
  );

  return useQuery({
    queryKey: [API_CACHE_KEYS.SELECTED_GEO_AREAS],
    queryFn: async () => {
      const geoAreaIds = await api.getSelectedGeoAreasForAppVariant();
      if (geoAreaIds.size === 0) {
        return [];
      }

      const geoAreas = await geoApi.getGeoAreas({
        geoAreaIds: [...geoAreaIds]
      });

      return geoAreas;
    },
    select: handleSelect
  });
};
